export const OIL_COLOR = '#24a148';
export const GAS_COLOR = '#da1e28';

export interface PriceCurveSeries {
  oil: [number, number][];
  gas: [number, number][];
  valOil?: [number, number][];
  valGas?: [number, number][];
  valOilLabel?: string;
  valGasLabel?: string;
  valVisible?: boolean;
}

export type HistoricRange = 0 | 12 | 60 | 120;

export interface PriceCurveChartProps {
  series: PriceCurveSeries;
  dates: number[];
  referenceLineTs?: number;
  filterMode: 'range' | 'projection';
  showHistoricControls?: boolean;
  historicRange?: HistoricRange;
  onHistoricRangeChange?: (months: HistoricRange) => void;
  onVisibleRangeChange?: (
    xMin: number | undefined,
    xMax: number | undefined
  ) => void;
  todayLineTs?: number;
}

/**
 * Computes start/end slice indices from the chart's visible xMin/xMax.
 * Returns null when no filtering should be applied.
 * @param {number[]} chartDates - Timestamps array (1:1 with data rows).
 * @param {number | undefined} xMin - Visible left boundary from chart.
 * @param {number | undefined} xMax - Visible right boundary from chart.
 * @return {Object | null} Slice bounds with start (inclusive) and end (exclusive), or null.
 */
export function getVisibleSliceBounds(
  chartDates: number[],
  xMin: number | undefined,
  xMax: number | undefined
): { start: number; end: number } | null {
  if (xMin === undefined && xMax === undefined) return null;

  const start = xMin !== undefined ? chartDates.indexOf(xMin) : 0;
  const endInclusive =
    xMax !== undefined ? chartDates.indexOf(xMax) : chartDates.length - 1;

  if (start < 0 || endInclusive < 0) return null;

  return { start, end: endInclusive + 1 };
}
